import React from 'react';
import { HeaderWrapper } from './styles.js';

function Header({vacancyTitle, companyName}) {
  return (
    <HeaderWrapper>
      <h1>{vacancyTitle}</h1>
      <h4>{companyName}</h4>
    </HeaderWrapper>
  );
}

export default Header;
